/*
 * drag 1.0 *  * 
 * 拖动滑块
 */
import request from '@/libs/axios'
import jQuery from "jquery";
function verify() {

    (function ($) {
        setTimeout(function () {
            var ctxPath = '';
            $.fn.drag = function (options) {
                var x, drag = this, isMove = false, defaults = {
                };
                var options = $.extend(defaults, options);
                //添加背景，文字，滑块
                var html = '<div class="drag_bg"></div>' +
                    '<div class="drag_text" onselectstart="return false;" unselectable="on">向右滑动验证</div>' +
                    '<div class="handler handler_bg"></div>';
                this.html(html);

                var handler = drag.find('.handler');
                var drag_bg = drag.find('.drag_bg');
                var text = drag.find('.drag_text');
                var maxWidth = drag.width() - handler.width() - 46;  //能滑动的最大间距

                var slideImg = $(".slideImg");
                //鼠标按下时候的x轴的位置
                handler.mousedown(function (e) {
                    isMove = true;
                    x = e.pageX - parseInt(handler.css('left'), 10);
                    //console.log(e)
                    $(".verifyCodeWrap").show()
                });
                handler.on({//绑定事件
                    // //                     touchstart事件下获取：e.originalEvent.targetTouches[0].pageX。
                    // // touchmove事件下获取：e.originalEvent.targetTouches[0].pageX。
                    // // touchend事件的下获取：e.originalEvent.changedTouches[0].pageX 。
                    touchstart: function (e) {
                        isMove = true;
                        x = e.originalEvent.targetTouches[0].pageX - parseInt(handler.css('left'), 10);
                        //console.log(e)
                        $(".verifyCodeWrap").show()
                    },
                    touchmove: function (e) {
                        // console.log(e)
                        var _x = e.originalEvent.targetTouches[0].pageX - x;
                        if (isMove) {
                            if (_x > 0 && _x <= maxWidth) {
                                handler.css({ 'left': _x });
                                slideImg.css({ 'left': _x });
                                drag_bg.css({ 'width': _x });
                            } else if (_x > maxWidth) {  //鼠标指针移动距离达到最大时清空事件                            
                                request.get('/auth/imageValidate/check', {
                                    x: parseInt(_x)
                                }).then((res) => {
                                    if (res) {
                                        dragOk(parseInt(_x));
                                    } else {
                                        dragNoOk();
                                        setTimeout(function () {
                                            dragInIt()
                                        }, 1000)
                                    }
                                })
                            }
                        }

                    },
                    touchend(e) {
                        isMove = false;
                        var _x = e.originalEvent.changedTouches[0].pageX - x;
                        if (_x < maxWidth) { //鼠标松开时，如果没有达到最大距离位置，滑块就返回初始位置
                            request.get('/auth/imageValidate/check', {
                                x: parseInt(_x)
                            }).then((res) => {
                                if (res) {
                                    dragOk(parseInt(_x));
                                } else {
                                    dragNoOk();
                                    setTimeout(function () {
                                        dragInIt()
                                    }, 1000)
                                }
                            })
                        }
                        if (x === undefined) {//如果没有移动
                            return false;
                        }
                    }
                })

                //鼠标指针在上下文移动时，移动距离大于0小于最大间距，滑块x轴位置等于鼠标移动距离
                $(document).mousemove(function (e) {
                    var _x = e.pageX - x;
                    if (isMove) {
                        if (_x > 0 && _x <= maxWidth) {
                            handler.css({ 'left': _x });
                            slideImg.css({ 'left': _x });
                            drag_bg.css({ 'width': _x });
                        } else if (_x > maxWidth) {  //鼠标指针移动距离达到最大时清空事件                            
                            request.get('/auth/imageValidate/check', {
                                x: _x
                            }).then((res) => {
                                if (res) {
                                    dragOk(_x);
                                } else {
                                    dragNoOk();
                                    setTimeout(function () {
                                        dragInIt()
                                    }, 1000)
                                }
                            })
                        }
                    }

                }).mouseup(function (e) {
                    isMove = false;
                    var _x = e.pageX - x;
                    if (_x < maxWidth) { //鼠标松开时，如果没有达到最大距离位置，滑块就返回初始位置
                        request.get('/auth/imageValidate/check', {
                            x: _x
                        }).then((res) => {
                            if (res) {
                                dragOk(_x);
                            } else {
                                dragNoOk();
                                setTimeout(function () {
                                    dragInIt()
                                }, 1000)
                            }
                        })
                    }
                    if (x === undefined) {//如果没有移动
                        return false;
                    }
                });

                //验证通过 清空事件
                function dragOk(x) {
                    $("#verifyX").val(x)
                    handler.removeClass('handler_bg').addClass('handler_ok_bg');
                    text.text('');
                    $(".handler_ok_bg").html('<div class="verifer_dui"></div>')
                    setTimeout(function () {
                        // $("#idCode").val("2")
                        $("#drag").addClass("yanzhengOk");
                        $("#drag").html('<div class="yanzhengOkItem"><img src=' + ctxPath + '"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAABX0lEQVQ4T7WTvyvFYRjFPycxWEwyq7spRqVIDGJQwiRlMBjYJP4CzEwGJSSLSVmkDJTBcq2YTEhJKMvRo/fKj6/vVa5nfHufz/uc55xX/FOpUlzbNcAO0Aw0VQRsOzjrwAhwDRQqBV4EZoB7oENS8c9g27PAPPAC9Eo6iPX+CWw7pMcKokYlbZY8ewPbngCKko5/a6btLmAPCNOmJC1/7JXtRuASeAb6Je2Xg9tuBUJyLbAgae5rT2niJWASeAL6JB3+BLddAEJZPRDSYwX+CRwPrADjwCPQI+no62XbAQtowHeBQUlh2rd6Ny9lcRUYS7EJ+Empw3YdEEpagDjvkhQKM+tTKmxXAWsp6JHJbkmn6VeFUWHYOdAm6SbPi29xS/AtYBi4CzgwnR67AjolXZQzODPHtquBbWAgBT8iFQraJZ2Vg+Z+kCR/I01+CwzlpSUzFXkT2G4AHvKMyup/BVwjeSU7BBjMAAAAAElFTkSuQmCC" >验证通过</div>')
                        $(".verifyCodeWrap").hide();
                    }, 300)
                    handler.unbind('mousedown');
                    $(document).unbind('mousemove');
                    $(document).unbind('mouseup');
                }
                //验证不通过 清空事件
                function dragNoOk() {
                    $(".drag_bg").addClass("drag_no_bg")
                    $(".drag_text").addClass("drag_no_text")
                    handler.removeClass('handler_bg').addClass('handler_Nook_bg');
                    text.text('');
                    $(".handler_Nook_bg").html('<div class="verifer_cuo"></div>')
                    drag.css({ 'color': '#F16B6B' });
                    handler.unbind('mousedown');
                    $(document).unbind('mousemove');
                    $(document).unbind('mouseup');
                }
            };

            dragInIt();
            function dragInIt() {
                $("#drag_text").html("加载中")
                // /imageValidate/imageShow
                request.get('/auth/imageValidate/imageShow', {}).then((res) => {
                    $(".bottomImg").attr("src", res.checkImg);
                    $(".slideImg").attr("src", res.checkImgMin);
                    $(".slideImg").css("top", res.y + 'px');
                    $("#drag_text").html("向右滑动验证")
                    $(".drag_bg").removeClass("drag_no_bg")
                    $(".drag_text").removeClass("drag_no_text")
                    $(".handler").addClass('handler_bg').removeClass('handler_Nook_bg');
                    $(".handler").css({ 'left': 0 });
                    $(".slideImg").css({ 'left': 0 });
                    $(".drag_bg").css({ 'width': 0 });
                    $(".handler_bg").html("")
                    $('#drag').drag();
                })

            }
            $(".verifyClose").click(function () {
                $(".verifyCodeWrap").hide();
            })
        }, 100)

    })(jQuery);


}
export {
    verify
}